<section class="contacto-section">

  <div class="contacto-card">

    <h2>CONTÁCTENOS</h2>

    <p>
      Nos gustaría escucharte y saber qué buscas para tu educación y crecimiento profesional,
      brindándote la información necesaria para que tomes la mejor decisión.
    </p>

    <p>
      Habla con un asesor especializado para que resuelva todas tus dudas y te ayude a formar
      un plan que se adapte a tus necesidades.
    </p>

    <ul class="contacto-list">
      <li>
        📍 <strong>Dirección:</strong> Calle 85 s/n entre 10B...
      </li>

      <li>
        📞 <strong>Tel:</strong> 982 6881598
      </li>
    </ul>

  </div>

</section>